import http from "../../http-common"
class NewsArticlesSearchAuthorsServices {
    getAllNewsArticlesAuthors() {
        return http.get('news-articles-search/authors')
    }
}

export default new NewsArticlesSearchAuthorsServices();